import { Injectable } from '@angular/core';
import { filter, take } from 'rxjs/operators';
import { AllocationViewActionsFacade } from '../allocation-view-actions.facade';
import { AllocationViewArrivalDockModel, AllocationViewSelectedEntityModel } from '../../models';
import { AllocationViewActionInterface } from '../models';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import {
  AllocationViewArriveAtDockConfirmationAction,
  AllocationViewArriveAtDockConfirmationActionPrepare,
  AllocationViewArriveAtDockConfirmationActionSetInitialState,
} from './allocation-view-arrive-at-dock-confirmation-action.actions';
import { AllocationViewArriveAtDockConfirmationActionState } from './allocation-view-arrive-at-dock-confirmation-action.state';

@Injectable({ providedIn: 'root' })
export class AllocationViewArriveAtDockConfirmationActionFacade implements AllocationViewActionInterface {
  loaded$: Observable<boolean> = this.store.select(AllocationViewArriveAtDockConfirmationActionState.getLoaded);
  arriveAtDockConfirmationPrepareData$: Observable<AllocationViewArrivalDockModel> = this.store.select(
    AllocationViewArriveAtDockConfirmationActionState.getArriveAtDockConfirmationPrepareData,
  );

  constructor(
    private allocationViewActionsFacade: AllocationViewActionsFacade,
    private translateService: TranslateService,
    private store: Store,
  ) {}

  arriveAtDockConfirmation(dock: AllocationViewArrivalDockModel): void {
    this.allocationViewActionsFacade.actionIdentifier$.pipe(filter(Boolean), take(1)).subscribe(() => {
      this.store.dispatch(new AllocationViewArriveAtDockConfirmationAction(dock));
    });
  }

  loadAll(): void {
    this.allocationViewActionsFacade.actionIdentifier$
      .pipe(filter(Boolean), take(1))
      .subscribe(({ identifier }: AllocationViewSelectedEntityModel) => {
        this.store.dispatch(
          new AllocationViewArriveAtDockConfirmationActionPrepare(identifier, this.translateService.currentLang),
        );
      });
  }

  setInitialState(): void {
    this.store.dispatch(new AllocationViewArriveAtDockConfirmationActionSetInitialState());
  }
}
